import isPlainObject from 'isobject';

var regex = new RegExp('^on([A-Z])');

function friendlyPseudoClass(style) {
  for (var property in style) {
    var value = style[property];

    if (isPlainObject(value)) {
      var resolvedValue = friendlyPseudoClass(value);

      if (regex.test(property)) {
        var pseudo = property.replace(regex, function (match, p1) {
          return ':' + p1.toLowerCase();
        });

        style[pseudo] = resolvedValue;
        delete style[property];
      } else {
        style[property] = resolvedValue;
      }
    }
  }

  return style;
}

export default (function () {
  return friendlyPseudoClass;
});